import { render, staticRenderFns } from "./success.vue?vue&type=template&id=0d38986e&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&id=0d38986e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38986e",
  null
  
)

export default component.exports